import React, { useEffect, useState } from "react";
import { Table, Container, Button, Modal, Col, Row } from "react-bootstrap";
import GetProducts from "../services/product.services";
import urlBackEnd from "../services/authServices";
import "../styles/listproducts.css";
import Cookies from "universal-cookie";
import {
  FaEdit,
  FaTrash,
  FaPaperPlane,
  FaRegSave,
} from "react-icons/fa";

function ListServices() {
  const cookies = new Cookies();
  const token = cookies.get('token');
  const [services, setServices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredServices, setFilteredServices] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showResendModal, setShowResendModal] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [selectedService, setSelectedService] = useState(null);

  // Close Modals
  const closeDeleteModal = () => setShowDeleteModal(false);
  const closeDetailsModal = () => setShowDetailsModal(false);
  const closeResendModal = () => setShowResendModal(false);

  // Show Modals
  const handleShowDeleteModal = (serviceId) => {
    setSelectedServiceId(serviceId);
    setShowDeleteModal(true);
  };

  const handleShowDetailsModal = (service) => {
    setSelectedService(service);
    setSelectedServiceId(service._id)
    setShowDetailsModal(true);
  };

  const handleShowResendModal = (service) => {
    setSelectedService(service);
    setShowResendModal(true);
  };

  // Delete Service
  const handleDelete = async () => {
    try {
      await fetch(`${urlBackEnd.servUrl}/${selectedServiceId}`, {
        method: "DELETE",
      });

      // Update state to remove the deleted service
      setServices((prevServices) =>
        prevServices.filter((service) => service._id !== selectedServiceId)
      );
      setFilteredServices((prevServices) =>
        prevServices.filter((service) => service._id !== selectedServiceId)
      );

      closeDeleteModal();
    } catch (error) {
      console.error("Error deleting service", error);
    }
  };

  // Edit Service
  const handleEdit = async () => {
    try {
        console.log('Updating service with data:', selectedService);

        if (!selectedService) {
            throw new Error("No service selected for editing");
        }

        const response = await fetch(
          `${urlBackEnd.servUrl}/edit/${selectedService._id}`,
          {
              method: "PUT",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(selectedService),
          }
        );

        const textResponse = await response.text(); // Get raw response text
        console.log('Raw response:', textResponse); // Log raw response

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`, textResponse);
            throw new Error("Failed to update the service");
        }

        let updatedService;
        try {
            updatedService = JSON.parse(textResponse);
        } catch (parseError) {
            console.error('Error parsing JSON:', parseError);
            throw new Error("Received invalid JSON response");
        }

        // Update the state with the newly updated service
        setServices((prevServices) =>
            prevServices.map((service) =>
                service._id === updatedService.data._id
                    ? updatedService.data
                    : service
            )
        );
        setFilteredServices((prevServices) =>
            prevServices.map((service) =>
                service._id === updatedService.data._id
                    ? updatedService.data
                    : service
            )
        );

        closeDetailsModal();
    } catch (error) {
        console.error("Error editing service", error);
        alert("Error editing service: " + error.message); // Show the error message
    }
};

//Handles Resend a Service


  // Search Function
  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);

    const filtered = services.filter((service) => {
      const lowerValue = value.toLowerCase();
      return (
        service.clientName.toLowerCase().includes(lowerValue) ||
        service.serviceName.toLowerCase().includes(lowerValue) ||
        service.technician.toLowerCase().includes(lowerValue)
      );
    });
    setFilteredServices(filtered);
  };

  //Fetch Services
  const fetchServices = async () => {
    const myHeaders = new Headers();
    console.log(token);
    myHeaders.append('Authorization', token); // Asegúrate de que la clave sea correcta
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
  
    try {
      const response = await fetch(`${urlBackEnd.servUrl}`, requestOptions);
      if (!response.ok) {
        const errorMessage = await response.text(); // Obtén el mensaje de error
        console.error("Error fetching products:", errorMessage);
        throw new Error("Error fetching products");
      }
      const data = await response.json();
      setServices(data);
      setFilteredServices(data);
    } catch (error) {
      console.error("Error fetching products", error);
      alert("Error fetching services. Please try again later.");
    }
  };
  

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <Container fluid className="product-list">
      <h2>Servicios</h2>
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearchInputChange}
        placeholder="Busqueda de servicios..."
      />
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Cliente</th>
            <th>Actividad</th>
            <th>Descripcion</th>
            <th>Tecnico</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {filteredServices.map((service) => (
            <tr key={service._id}>
              <td>{service.created.slice(0, 10)}</td>
              <td>{service.clientName}</td>
              <td>{service.serviceName}</td>
              <td>{service.description}</td>
              <td>{service.technician}</td>
              <td id="button">
                <Button
                  style={{ margin: "5px" }}
                  className="btn-sm"
                  variant="success"
                  onClick={() => handleShowResendModal(service)}
                >
                  <FaPaperPlane />
                </Button>
                <Button
                  style={{ margin: "5px" }}
                  className="btn-sm"
                  variant="primary"
                  onClick={() => handleShowDetailsModal(service)}
                >
                  <FaEdit />
                </Button>
                <Button
                  variant="danger"
                  style={{ margin: "5px" }}
                  className="btn-sm"
                  onClick={() => handleShowDeleteModal(service._id)}
                >
                  <FaTrash style={{ color: "white" }} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres eliminar este Servicio?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleDelete}>
            Borrar <FaTrash />
          </Button>
          <Button variant="secondary" onClick={closeDeleteModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Resend Modal */}
      <Modal show={showResendModal} onHide={closeResendModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reenviar Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres reenviar el Servicio?</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => {/* Resend action */}}>
            Enviar <FaPaperPlane />
          </Button>
          <Button variant="secondary" onClick={closeResendModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Details Modal */}
      <Modal size="lg" show={showDetailsModal} onHide={closeDetailsModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <Container>
            {selectedService ? (
              <Row>
                <Col xs={12} md={8}>
                  <strong>Cliente:</strong>
                  <input
                    type="text"
                    value={selectedService.clientName}
                    onChange={({ target: { value } }) =>
                      setSelectedService({ ...selectedService, clientName: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Col xs={6} md={4}>
                  <strong>Servicio:</strong>
                  <input
                    type="text"
                    value={selectedService.serviceName}
                    onChange={({ target: { value } }) =>
                      setSelectedService({ ...selectedService, serviceName: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={8}>
                  <strong>Fecha:</strong>
                  <input
                    type="date"
                    value={selectedService.created.slice(0, 10)}
                    onChange={({ target: { value } }) =>
                      setSelectedService({ ...selectedService, created: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={8}>
                  <strong>Técnico:</strong>
                  <input
                    type="text"
                    value={selectedService.technician}
                    onChange={({ target: { value } }) =>
                      setSelectedService({ ...selectedService, technician: value })
                    }
                    className="form-control"
                  />
                </Col>
                <Row>
                  <Col>
                    <strong>Actividad:</strong>
                    <textarea
                      type="text"
                      value={selectedService.description}
                      onChange={({ target: { value } }) =>
                        setSelectedService({ ...selectedService, description: value })
                      }
                      className="form-control"
                    />
                  </Col>
                </Row>
              </Row>
            ) : null}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleEdit}>
            Guardar <FaRegSave />
          </Button>
          <Button variant="secondary" onClick={closeDetailsModal}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ListServices;
